import React from 'react';
import { Wallet } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import ModuleAlertsPage from '../../shared/components/ModuleAlertsPage';
import { formatBrandMoney, getBrandLocale } from '../../shared/utils/brandCurrency';
import { buildDefaultTreasuryConfig } from './treasurySaudiHelpers';

const CaisseAlertsPage = () => {
  const { t } = useTranslation();
  const p = (key, opts) => t(`modules.caisse.pages.caisseAlertsPage.${key}`, opts);
  const config = buildDefaultTreasuryConfig();
  const formatAlertDate = (dateInput) =>
    new Date(dateInput).toLocaleDateString(getBrandLocale('ar'), {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });

  const alerts = [
    {
      id: 1,
      type: 'error',
      priority: 'critical',
      title: p('alert_critical_balance_title'),
      message: p('alert_critical_balance_message', { threshold: formatBrandMoney(config.minCashAmount) }),
      date: formatAlertDate(new Date()),
      read: false,
      amount: config.minCashAmount - 1500,
    },
    {
      id: 2,
      type: 'warning',
      priority: 'high',
      title: p('alert_closure_title'),
      message: p('alert_closure_message', { time: config.autoClosureTime }),
      date: formatAlertDate(new Date()),
      read: false,
    },
    {
      id: 3,
      type: 'info',
      priority: 'medium',
      title: p('alert_reconciliation_title'),
      message: p('alert_reconciliation_message', { tolerance: formatBrandMoney(config.maxDiscrepancy) }),
      date: formatAlertDate(new Date(Date.now() - 86400000)),
      read: true,
      amount: config.maxDiscrepancy + 25,
    },
  ];

  return <ModuleAlertsPage moduleName={p('module_name')} moduleIcon={Wallet} alerts={alerts} />;
};

export default CaisseAlertsPage;
